import { Button, type ButtonProps } from "~/common/components/Button/Button";
import StoreIcon from "@mui/icons-material/Store";
import { useTranslation } from "react-i18next";
import { openModal } from "~/AddToCart/ModalSevice";
import { BuyFromSalesPartnerModal } from "./BuyFromSalesPartnerModal/BuyFromSalesPartnerModal";
import type { ProductData } from "~/models/ProductData";
import { trackBuyFromSalesPartnerButton } from "~/feature/Analytics/ga/ga";
import type { GAPageTypeName } from "~/Search/useSearchPageType";

export const BuyFromSalesPartnerButton = ({
  product,
  onClick: onClickExternal,
  pageType,
  quantity,
  ...props
}: Omit<ButtonProps, "children" | "startIcon"> & {
  product: ProductData;
  pageType: GAPageTypeName;
  quantity?: number;
}) => {
  const { onClick, icon, label } = useBuyFromSalesPartnerButtonProps({ onClickExternal, product, pageType, quantity });

  return (
    <Button startIcon={icon} onClick={onClick} fullWidth {...props}>
      {label}
    </Button>
  );
};

interface UseBuyFromSalesPartnerButtonProps {
  onClickExternal?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  product: ProductData;
  pageType: GAPageTypeName;
  quantity?: number;
}

export const useBuyFromSalesPartnerButtonProps = ({
  onClickExternal,
  product,
  pageType,
  quantity,
}: UseBuyFromSalesPartnerButtonProps) => {
  const { t } = useTranslation();

  const onClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    onClickExternal?.(e);
    trackBuyFromSalesPartnerButton(product.designation, product.sapMaterialNumber, pageType);
    openModal("buy-from-sales-partner-modal", (close) => (
      <BuyFromSalesPartnerModal onClose={close} product={product} pageType={pageType} quantity={quantity} />
    ));
  };

  return {
    key: "buy-from-sales-partner",
    icon: <StoreIcon />,
    testId: "button-buy-from-sales-partner",
    onClick,
    label: t("addToCart.salesPartner.button"),
  };
};
